export default __webpack_public_path__ + "static/media/pigeonLogo.919fb056.png";